import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { Subtitulo, Line, EnhancedTable } from '@monorepo-web/components-library';
import {
  sendAnalyticsData,
  MoneyPrefix,
  useAppSelector,
  useAppDispatch,
  useFetchAPIs,
  formatRowsInfos1,
  formatRowsInfos2,
  formatRowsDefault,
  getColumnsInfo1,
  getColumnsInfo2,
  getColumnsDefault,
} from '@monorepo-web/logic-extrato';

import HeaderWrapper from '../../MainLayout/HeaderWrapper';
import { TabelaEstatisticas, TabelaInformacoesAdicionais } from '@monorepo-web/templates';

interface Props {
  dispatchPDF?: boolean;
  sendData?: any;
  moneyPrefixParam?: string;
}

export default function EstatisticasAvancadas({ dispatchPDF, sendData, moneyPrefixParam }: Props) {
  const dispatch = useAppDispatch();
  const [
    infos_add,
    retorno_carteira_bench,
    vol_carteira_bench,
    sharpe_carteira_bench,
    obj_datas,
    isLoaded,
    loading,
    carteiraList,
    loadedCarteiraList,
    isLoadingMinimized,
    params,
    preferenceCustomizacao,
  ] = useAppSelector((state) => [
    state.estats.infos_add,
    state.estats.retorno_carteira_bench,
    state.estats.vol_carteira_bench,
    state.estats.sharpe_carteira_bench,
    state.estats.obj_datas,
    state.estats.isLoaded,
    state.estats.loading,
    state.preference.carteiraList,
    state.preference.loadedCarteiraList,
    state.loadMinimized.isLoadingMinimized,
    state.preference.params,
    state.preference.preferenceStyle.customizacao,
  ]);

  useEffect(() => {
    if (!dispatchPDF) document.title = `${(window as any).env.REACT_APP_TABNAME} - Estatísticas`;
  }, []);
  useEffect(() => {
    if (isLoaded && !dispatchPDF) dispatch(sendAnalyticsData(location.href));
  }, [params, isLoaded]);

  useFetchAPIs(isLoaded, loading, dispatchPDF);

  const moneyPrefix = moneyPrefixParam ?? MoneyPrefix(carteiraList, params.carteira);

  // const rowsInfos1 = useMemo(() => {
  //   if (!isLoaded) return null;

  //   let rows = formatRowsInfos1(infos_add, obj_datas, moneyPrefix);
  //   if(preferenceCustomizacao?.EstatAvancada_removerLinhaSharpeTabInfo1) rows = rows?.filter((row: any) => row.info !== 'Índice Sharpe no Período') || null;
  //   return rows;
  // }, [isLoaded]);

  let rowsInfos1 = formatRowsInfos1(infos_add, obj_datas, moneyPrefix);
  if (preferenceCustomizacao?.EstatAvancada_removerLinhaSharpeTabInfo1)
    rowsInfos1 = rowsInfos1?.filter((row: any) => row.info !== 'Índice Sharpe no Período') || null;
  const columnsInfos1 = getColumnsInfo1(infos_add);

  const rowsInfos2 = formatRowsInfos2(infos_add);
  const columnsInfos2 = getColumnsInfo2();

  const rowsRetornos = formatRowsDefault(retorno_carteira_bench);
  const rowsVol = formatRowsDefault(vol_carteira_bench);
  const rowsSharpe = formatRowsDefault(sharpe_carteira_bench, true);
  const bench = infos_add && infos_add.retorno ? infos_add.retorno[0][2].toString() : '-';
  const benches = retorno_carteira_bench && retorno_carteira_bench[0] ? retorno_carteira_bench[0].slice(2) : [];

  const columnsDefault = getColumnsDefault(retorno_carteira_bench);

  useEffect(() => {
    if (dispatchPDF) {
      const data = {
        rowsInfos1,
        columnsInfos1,
        rowsInfos2,
        columnsInfos2,
        rowsRetornos,
        rowsVol,
        rowsSharpe,
        columnsDefault,
        bench,
        benches
      };
      sendData('EstatAvancada', data);
    }
  }, []);

  if (dispatchPDF) {
    return <></>;
  }

  return (
    <>
      <Grid>
        <HeaderWrapper title="Estatísticas Avançadas" periodo obj_datas={obj_datas} subtitle_date />
        <Line />
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Subtitulo mb="8px">Informações Adicionais</Subtitulo>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              md={preferenceCustomizacao?.EstatAvancada_removerTabMaiorMenor ?? false ? 12 : 6}>
              <TabelaInformacoesAdicionais
                rows={rowsInfos1}
                bench={bench}
                titulo=''
              />
            </Grid>
            {preferenceCustomizacao?.EstatAvancada_removerTabMaiorMenor ?? false ? null : (
              <Grid item xs={12} md={6}>
                <TabelaInformacoesAdicionais rows={rowsInfos2} layout='info2' titulo=''/>
              </Grid>
            )}
          </Grid>
        </Grid>
        {preferenceCustomizacao?.EstatAvancada_removerTabRetorno ?? false ? null : (
          <Grid item xs={12}>
            <TabelaEstatisticas
              rows={rowsRetornos}
              benches={benches}
              titulo='Retorno'
            />
          </Grid>
        )}
        {preferenceCustomizacao?.EstatAvancada_removerTabVol ?? false ? null : (
          <Grid item xs={12}>
            <TabelaEstatisticas
              rows={rowsVol}
              benches={benches}
              titulo='Volatilidade'
            />
          </Grid>
        )}
        {preferenceCustomizacao?.EstatAvancada_removerTabSharpe ?? false ? null : (
          <Grid item xs={12}>
            <TabelaEstatisticas
              rows={rowsSharpe}
              benches={benches}
              titulo='Índice Sharpe'
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}
